<template>

	<div :class="['footer',type]">
		<!-- 改为href -->

		<a v-for="(item,i) in arr" :key="i" :href="item.route" class="item"
			:class="{'active' : route.path.includes(item.route) }"
		>
			<div v-if="!item.type" :class="item.class">{{item.name}}</div>
			<div v-else :class="item.class">

				<div class="app_open">
					<wx-open-launch-app
						class="launch-btn"
						@error="handleError"
						@launch="handleLaunch"
						:extinfo="
							JSON.stringify({
								kind: 'circleMain',
								id: id
							})
						"
						appid="wxd4d02956bdca92eb"
					>
						<script type="text/wxtag-template">
							<p class="open-app-btn" style="width:999px;height:999px;"></p>
						</script>
					</wx-open-launch-app>
				</div>

			</div>
		</a>

	</div>


</template>

<script>
    export default {
		props:{
			type:String,//圈子类型
			id:Number,//圈子id
		},
        name: "agqFooter",
		data(){
        	return {
        		active:0,
				arr:[
					{
						name:'圈子',
						route:'/index',
						class:'index'
					},
					{
						name:'消息',
						route:'/message',
						class:'message'
					},
					{
						name:'我的',
						route:'/my',
						class:'my'
					},
				],
				route:this.$route,
			}
		},
		created(){
			console.log(this.$route)
			if(this.type){
				this.arr = [
					{
						name:'圈子',
						route:'/index',
						class:'index'
					},
					{
						type:'app',
						route:'javascript:;',
						class:'app'
					},
					{
						name:'我的',
						route:'/my',
						class:'my'
					},
				]
			}
		},
		methods:{
			handleError(e) {
			// 跳转APP失败
			console.log(JSON.stringify(e), "跳转失败", e.detail);
			// 这里跳转App下载页面
			location.href =
				"https://a.app.qq.com/o/simple.jsp?pkgname=com.aiguquan.main";
			},
			handleLaunch(e) {
				// 跳转APP成功
				console.log(JSON.stringify(e), "跳转成功", e.detail);
			},
		}
    }
</script>

<style scoped lang="scss">
	.footer{
		border-top: 1px solid #EBEBEB;
		background: #FFFFFF;
		width: 100vw;
		display: flex;
		position: fixed;
		bottom: 0;
		left: 0;
		height: 49px;
		font-size: 12px;
		.item{
			flex: 1;
			text-align: center;
			line-height: 80px;
			color: #979A9D;
			>div{
				background: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/circle.png") no-repeat;
				background-size: 24px;
				background-position: center 5px;
			}
			.message{
				background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/mes.png");
			}
			.my{
				background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/my.png");
			}

			.app{
				display: flex;
				align-items: center;
				height: 100%;
				justify-content: center;
				
			}

			.app_open{
				width: 120.5px;
				height: 36px;
				background: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/app2.png") no-repeat;
				background-size: 100%;
				position: relative;
			}
		}
		.active{
			color: #FF1313;
			.index{
				background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/circle2.png");
			}
			.message{
				background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/mes2.png");
			}
			.my{
				background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/my2.png");
			}
		}
	}
</style>
